function FanBudgetLanding() {
  return (
    <iframe
      title="FanBudget"
      src="https://fanbudget.lk/"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        display: 'block',
      }}
    />
  );
}

export default FanBudgetLanding;
